module.exports = __webpack_public_path__ + "static/media/on-eye_classic-Radiant.d37b9d74.jpg";